import { Close } from "@/components/Icons/utility/Close.tsx";
import { useGetCancelationPolicyTranslated } from "@/helpers/translation/useGetCancelationPolicyTranslated.ts";
import { CancelationPolicy } from "@/helpers/types/types.ts";
import { useModalStore } from "@/stores/ModalStore/useModalStore.ts";
import DOMPurify from "dompurify";
import { useTranslation } from "react-i18next";

export const RPCancelationPolicyModalDetailed = () => {
  const { t } = useTranslation();
  const editObj = useModalStore<CancelationPolicy>((s) => s.editObj as CancelationPolicy);
  const closeModal = useModalStore((s) => s.closeModal);
  const { name, description } = useGetCancelationPolicyTranslated(editObj);

  return (
    <div className="c-policy-modal">
      <div className="c-policy-modal__close">
        <button className="c-close-button" onClick={() => closeModal()} aria-label="Close modal">
          <Close />
        </button>
      </div>
      <div className="c-policy-modal__header">
        <h5 className="u-h5 u-fw-600">{name || t("generalTermsAndConditions")}</h5>
      </div>
      {description && (
        <div
          className="c-policy-modal__content u-rte u-rte--document"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
        />
      )}
    </div>
  );
};
